import React, { FunctionComponent } from "react";

const FeaturedStarIcon: FunctionComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
    >
      <rect
        x="0.0898438"
        y="0.42041"
        width="22.4595"
        height="20.1595"
        rx="4"
        fill="#57534E"
      />
      <path
        d="M10.8151 4.14286C11.0027 3.78728 11.5119 3.78728 11.6995 4.14286L13.3419 7.25571C13.4143 7.39283 13.5461 7.48864 13.6989 7.51507L17.1669 8.11512C17.563 8.18367 17.7204 8.66798 17.4402 8.95628L14.9872 11.4802C14.8792 11.5914 14.8288 11.7464 14.8509 11.8998L15.3519 15.3835C15.4091 15.7815 14.9971 16.0808 14.6363 15.9034L11.4779 14.3504C11.3388 14.282 11.1758 14.282 11.0367 14.3504L7.87831 15.9034C7.51754 16.0808 7.10555 15.7815 7.16278 15.3835L7.66377 11.8998C7.68584 11.7464 7.63547 11.5914 7.52742 11.4802L5.07444 8.95628C4.79424 8.66798 4.9516 8.18367 5.34774 8.11512L8.81576 7.51507C8.96853 7.48864 9.10039 7.39283 9.17274 7.25571L10.8151 4.14286Z"
        fill="#FFEB2D"
      />
    </svg>
  );
};

export default FeaturedStarIcon;
